<template>
  <div id="data-list-list-view" class="data-list-container">
    <h1>{{ $t("activated_liftingEquipments") }}</h1>
    <br />
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vs-table
      ref="table"
      pagination
      :max-items="itemsPerPage"
      search
      :data="liftingEquipments"
    >
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <!-- ADD NEW -->
          <!--  <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">{{ $t("Ajouter") }}</span>
            </div> -->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown
          vs-trigger-click
          class="cursor-pointer mb-4 mr-4 items-per-page-handler"
        >
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                liftingEquipments.length - currentPage * itemsPerPage > 0
                  ? currentPage * itemsPerPage
                  : liftingEquipments.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 40">
              <span>40</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 60">
              <span>60</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 80">
              <span>80</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="name">{{ $t("equipmentTypes") }}</vs-th>
        <vs-th sort-key="norm">{{ $t("norm") }}</vs-th>
        <vs-th sort-key="norm">{{ $t("otherNorm") }}</vs-th>
        <vs-th sort-key="norm">{{ $t("number") }}</vs-th>
        <vs-th sort-key="company">{{ $t("company") }}</vs-th>
        <vs-th sort-key="created_at">{{ $t("created_at") }}</vs-th>
        <vs-th sort-key="updated_at">{{ $t("updated_at") }}</vs-th>
        <vs-th sort-key="greyCard">{{ $t("nokiaValidation") }}</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.equipmentType.name }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.equipmentType.norm }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.otherNorm !== null ? tr.otherNorm : "-" }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.number }}</p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.company !== null ? tr.company.name : "-" }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.created_at | moment }}
              </p>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">
                {{ tr.updated_at | moment }}
              </p>
            </vs-td>
            <vs-td>
              <vs-chip
                v-if="getlang === 'fr'"
                :color="getOrderStatusColor(tr.activated)"
                class="product-order-status"
                >{{ validationObject[tr.activated] }}</vs-chip
              >
              <vs-chip
                v-if="getlang === 'en'"
                :color="getOrderStatusColor(tr.activated)"
                class="product-order-status"
                >{{ validationObject_en[tr.activated] }}</vs-chip
              >
            </vs-td>
            <vs-td class="whitespace-no-wrap">
              <div class="flex">
                <vx-tooltip :text="$t('Voir')" color="success">
                  <feather-icon
                    style="color: #50c00e"
                    icon="ImageIcon"
                    svgClasses="w-5 h-5 hover:text-success stroke-current"
                    class="mr-2"
                    @click="openImage(tr.picture)"
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="
                    role !== 'nokiaProject' &&
                    role !== 'qhsNokia' &&
                    role !== 'teamLeaderSubcontractor' &&
                    role !== 'pessNokia'
                  "
                  :text="$t('Modifier')"
                  color="warning"
                >
                  <feather-icon
                    style="color: #ff9f43"
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-warning stroke-current"
                    class="mr-2"
                    @click="editData(tr)"
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="
                    role !== 'nokiaProject' &&
                    role !== 'qhsNokia' &&
                    role !== 'teamLeaderSubcontractor' &&
                    role !== 'pessNokia'
                  "
                  :text="$t('Supprimer')"
                  color="danger"
                >
                  <feather-icon
                    @click="deleteData(tr.id)"
                    style="color: red"
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip :text="$t('valider_equipement')" color="success">
                  <feather-icon
                    v-if="role !== 'managerSubcontractor'"
                    @click="comfirmation(tr.id)"
                    style="color: #06ac0e"
                    icon="CheckCircleIcon"
                    svgClasses="w-5 h-5 hover:text-success stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="role !== 'managerSubcontractor'"
                  :text="$t('rejeter_equipement')"
                  color="danger"
                >
                  <feather-icon
                    @click="rejet_Pop(tr.id)"
                    style="color: #ff6141"
                    icon="XCircleIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
                <vx-tooltip
                  v-if="tr.activated === 0"
                  :text="$t('rapport')"
                  color="dark"
                >
                  <feather-icon
                    @click="rapport(tr.liftingEquipmentComments)"
                    style="color: black"
                    icon="FileTextIcon"
                    svgClasses="w-5 h-5 hover:text-dark stroke-current"
                    class="mr-2"
                  />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <vs-popup
      classContent="popup-example"
      :title="$t('ajouter_votre_commentaire')"
      :active.sync="activePrompt4"
    >
      <vs-textarea v-model="comment" rows="5" class="w-full"> </vs-textarea>
      <div class="flex flex-wrap justify-between mt-5">
        <vs-button
          color="danger"
          type="filled"
          icon-pack="feather"
          icon="icon-minus-circle"
          @click="resetData_comfirmation"
          >{{ $t("Annuler") }}</vs-button
        >
        <vs-button
          :disabled="!validate_comment"
          color="success"
          type="filled"
          icon-pack="feather"
          icon="icon-plus-circle"
          @click="rejete_comfirmation"
          >Valider</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      classContent="popup-example"
      :title="$t('details_du_rejet')"
      :active.sync="activePrompt5"
    >
      <li class="mb-2" v-for="comment in details" :key="comment">
        {{ comment.comment }}
      </li>
    </vs-popup>
  </div>
</template>
<script>
import DataViewSidebar from './DataViewSidebarLiftingEquipments.vue'

export default {
  components: {
    DataViewSidebar
  },
  data () {
    return {
      role: '',
      activePrompt5: false,
      activePrompt4: false,
      comment: '',
      team_id: '',
      validationObject: {
        0: 'Rejeté',
        1: 'Encours',
        2: 'Validé'
      },
      validationObject_en: {
        0: 'Rejected',
        1: 'Verification',
        2: 'Valid'
      },
      details: [],
      liftingEquipments: [],
      selected: [],
      itemsPerPage: 20,
      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {}
    }
  },
  computed: {
    validate_comment () {
      if (this.comment !== '') return true
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.liftingEquipments.length
    }
  },
  methods: {
    openImage (file) {
      window.open(
        `https://test.jra.mitigarisk.com/digira/${file.substring(39)}`,
        '_blank'
      )
    },
    rapport (tr) {
      this.details = []
      this.activePrompt5 = true
      this.details = tr
    },
    rejete_comfirmation () {
      const input = {
        liftingEquipment: this.liftingEquipment_id,
        comment: this.comment
      }
      //const vehicle = this.liftingEquipment_id
      //const comment = this.comment
      this.$vs.loading()
      this.$http
        .post('reject-liftingEquipment/', input)
        .then((response) => {
          this.getAllLiftingEquipments()
          window.getPrendTaCom.success(this.$t('rejet_equiment'), response)
        })
        .catch(() => {
          window.getPrendTaCom.error({ message: this.$t('echec_equiment') })
        })
      this.activePrompt4 = false
    },
    comfirmation (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'success',
        title: 'Confirmation',
        text: this.$t('comfirm_validation'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          const liftingEquipment = id
          this.$vs.loading()
          this.$http
            .post('validate-liftingEquipment/', { liftingEquipment })
            .then((response) => {
              this.getAllLiftingEquipments()
              window.getPrendTaCom.success(
                this.$t('valide_equiment'),
                response
              )
            })
            .catch(() => {
              window.getPrendTaCom.error({
                message: this.$t('echec_equiment')
              })
            })
        }
      })
    },

    resetData_comfirmation () {
      this.comment = ''
      this.liftingEquipment_id = ''
      this.activePrompt4 = false
    },
    rejet_Pop (id) {
      this.liftingEquipment_id = id
      this.comment = ''
      this.activePrompt4 = true
    },
    getOrderStatusColor (status) {
      if (status === 0) {
        return 'danger'
      } else if (status === 1) {
        return 'warning'
      } else if (status === 2) {
        return 'success'
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },

    deleteData (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmation',
        text: this.$t('enteteDelete'),
        acceptText: this.$t('Confirmer'),
        cancelText: this.$t('Annuler'),
        accept: async () => {
          this.$vs.loading()
          this.$http
            .delete(`liftingEquipments/${id}/`)
            .then((response) => {
              this.getAllLiftingEquipments()
              window.getPrendTaCom.success(
                this.$t('SuppressionliftingEquipment'),
                response
              )
            })
            .catch(() => {
              window.getPrendTaCom.error({ message: this.$t('Suppression') })
            })
        }
      })
    },
    ShowData (tr) {
      //window.open(`${this.$http.defaults.baseURL  }storage/fiche_de_besoin/${id}.pdf`, '_blank')
      window.open(
        `https://test.jra.mitigarisk.com/digira/${tr.picture.substring(39)}`,
        '_blank'
      )
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },

    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
    },
    getAllLiftingEquipments () {
      this.$vs.loading()
      this.$http
        .get('activated-liftingEquipments/')
        .then((response) => {
          this.liftingEquipments = response.data
          this.$vs.loading.close()
        })
        .catch(() => {
          this.$vs.loading.close()
        })
    }
  },
  async created () {
    const user_role = JSON.parse(localStorage.getItem('userInfo')).role
    this.role = user_role
    window.liftingEquipments = this
    this.getAllLiftingEquipments()
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>

<style scoped></style>

<style scoped></style>
